import React, { Component } from 'react';
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from '@material-ui/core/Tooltip';
import { getColorFromStatusLabel, getIconNameFromStatusLabel, formatStatus } from '../../redux/quote/quoteStatus'
import '../../statusIcon.css'
import { getCurrentFunctionName } from '../../performanceModeManager';

class QuoteStatusIcon extends Component {
    render() {
        console.perfLog(getCurrentFunctionName());
        let iconElement;

        iconElement = (
            <Icon className={this.props.className + " status-icon-color-" + getColorFromStatusLabel(this.props.state, this.props.internalState, this.props.lowlight)}>
                {getIconNameFromStatusLabel(this.props.state, this.props.internalState)}
            </Icon>
        );

        return (
            <Tooltip title={formatStatus(this.props.state, this.props.internalState)}>
                {iconElement}
            </Tooltip>
        );
    }
}

export default QuoteStatusIcon;
